// Libraries
import { Box, Flex, Text } from "@chakra-ui/react";
import { ResponsivePie } from "@nivo/pie";
import React from "react";
import { ZeroAnalytics } from "../../UI/Errors/Empty";

const AllClassesAnalytics = ({ loading, data, chartDataLabels }) => {
  return (
    <>
      <Box m="auto" pos="relative" width="100%" h="100%">
        {!loading && (
          <>
            <Text fontWeight="700" color="gray.500" textAlign="center" px={4} mb={3}>
              Lessons you spent most time on(minutes)
            </Text>

            {data?.length === 0 ? (
              <ZeroAnalytics my="auto" />
            ) : (
              <>
                <Box h={170}>
                  <ResponsivePie
                    data={data}
                    innerRadius={0.7}
                    padAngle={0.7}
                    colors={["#afd1ff", "#4895ff", "#005EE9"]}
                    borderWidth={1}
                    borderColor={{
                      from: "color",
                      modifiers: [["darker", 0.2]],
                    }}
                    radialLabelsSkipAngle={10}
                    radialLabelsTextColor="#333333"
                    radialLabelsLinkColor={{ from: "color" }}
                    sliceLabelsSkipAngle={10}
                    sliceLabelsTextColor="#333333"
                    enableRadialLabels={false}
                    legends={[
                      {
                        anchor: "bottom",
                        direction: "row",
                        justify: false,
                        translateX: 0,
                        translateY: 56,
                        itemsSpacing: 0,
                        itemWidth: 100,
                        itemHeight: 18,
                        itemTextColor: "#999",
                        itemDirection: "left-to-right",
                        itemOpacity: 1,
                        symbolSize: 18,
                        symbolShape: "circle",
                        effects: [
                          {
                            on: "hover",
                            style: {
                              itemTextColor: "#000",
                            },
                          },
                        ],
                      },
                    ]}
                  />
                </Box>

                <Flex mt={4} flexDir="column" w="100%" fontSize="13px" fontWeight={700} color="gray.600">
                  {chartDataLabels &&
                    chartDataLabels.length > 0 &&
                    chartDataLabels.map((label: any, index: number) => {
                      if (label.value) {
                        return (
                          <Flex key={index} mb={1} mx="auto">
                            <Box w="10px" h="10px" my="auto" borderRadius="full" bg={label.color} mr={2}></Box>
                            <Text my="auto">{label.value}</Text>
                          </Flex>
                        );
                      }
                    })}
                </Flex>
              </>
            )}
          </>
        )}
      </Box>
    </>
  );
};

export default AllClassesAnalytics;
